import React from 'react';
import type { OmdPanelSettings } from '../../../utils/omdPanelSettings';
import { getDensityClasses } from '../../../utils/omdPanelSettings';
import { getOmdSectionIcon, OmdPanelIcon } from '../omdPanelIcons';

type OmdSectionProps = {
  title: string;
  settings: OmdPanelSettings;
  children: React.ReactNode;
  hidden?: boolean;
};

export function OmdSection({ title, settings, children, hidden }: OmdSectionProps) {
  const density = getDensityClasses(settings.density);
  const SectionIcon = getOmdSectionIcon(title);
  if (hidden) return null;
  return (
    <section className={`rounded-lg border border-app-border bg-app-surface ${density.section}`}>
      <h3 className={`flex items-center gap-2 font-semibold text-app-text mb-2 ${density.heading}`}>
        <OmdPanelIcon icon={SectionIcon} />
        {title}
      </h3>
      {children}
    </section>
  );
}
